import { render, staticRenderFns } from "./BrandsafetyClassifiersModal.vue?vue&type=template&id=baa11d6c&scoped=true&"
import script from "./BrandsafetyClassifiersModal.vue?vue&type=script&lang=js&"
export * from "./BrandsafetyClassifiersModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandsafetyClassifiersModal.vue?vue&type=style&index=0&id=baa11d6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa11d6c",
  null
  
)

export default component.exports